// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 14V10H17V14H15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V21H23V3ZM7 11H9V8H11V16H9V13H7V16H5V8H7V11ZM17 8C18.1046 8 19 8.89543 19 10V14C19 15.1046 18.1046 16 17 16H13V8H17Z"}}]};

const HdFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hd-filled',
    ref,
    icon: element,
  },
));

HdFilledIcon.displayName = 'HdFilledIcon';

export default HdFilledIcon;
